import { getPageRootElement } from '../helpers';

enum BackgroundDataAttribute {
	deps = 'data-deps', // is set to element to allow a server to add background slider resources to publication dependencies
}

export const getBackgroundDeps = (htmlDocument: Document): string[] | undefined => {
	const pageRoot = getPageRootElement(htmlDocument);
	const outerElement = htmlDocument.body.firstElementChild as HTMLElement | null;
	// the two are the same element unless the page is wrapped, so read whichever has the attribute
	const depsAttr = (pageRoot && pageRoot.getAttribute(BackgroundDataAttribute.deps))
		|| (outerElement && outerElement.getAttribute(BackgroundDataAttribute.deps));

	return depsAttr ? depsAttr.split(';') : undefined;
};

export const saveBackgroundDeps = (htmlDocument: Document, deps?: string[]): void => {
	const pageRoot = getPageRootElement(htmlDocument);
	const outerElement = htmlDocument.body.firstElementChild as HTMLElement | null;

	if (!pageRoot) {
		return;
	}

	const candidates = outerElement && outerElement !== pageRoot ? [pageRoot, outerElement] : [pageRoot];
	// leave the attribute on the element that already carries it, so a page saved before pages could be
	// wrapped is not moved out from under the server
	const target = candidates.find(element => element.hasAttribute(BackgroundDataAttribute.deps)) || pageRoot;

	// the server reads one attribute, so never leave a second one behind
	candidates.forEach(element => element.removeAttribute(BackgroundDataAttribute.deps));

	if (deps && deps.length > 0) {
		target.setAttribute(BackgroundDataAttribute.deps, deps.join(';'));
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/backgroundDeps.ts